import { Dict } from "../models/base/Dict";

export const buildQueryString = (queryParams: Dict): string => {
  if (!queryParams || !Object.keys(queryParams).length) return ``;
  const qs = Object.keys(queryParams)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key]))
    .join("&");
  if (qs) return `?${qs}`;
  return ``;
};
